/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Workavailabilities1Inputs */

const de__field_workavailabilities1 = /** @type {(inputs: _Field_Workavailabilities1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arbeitsverfügbarkeiten`)
};

/**

* @param {_Field_Workavailabilities1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_workavailabilities1 = /** @type {((inputs?: _Field_Workavailabilities1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Workavailabilities1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_workavailabilities1(inputs)
});
export { _field_workavailabilities1 as "_field_workAvailabilities" }